import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { forwardRef } from 'react';

export const DownwardTreeIcon = forwardRef<SVGSVGElement, SvgWrapperProps>(
  (props, ref) => (
    <SvgWrapper fill='none' ref={ref} viewBox='0 0 16 16' {...props}>
      <circle
        cx='7.5'
        cy='14.5'
        r='1.5'
        transform='rotate(-90 7.5 14.5)'
        fill='currentColor'
      />
      <path
        d='M7.5 7.5L1.5 7.5L1.5 1.5M7.5 7.5L7.5 14.5M7.5 7.5L14.5 7.5L14.5 1.5'
        stroke='currentColor'
      />
      <path d='M10.5 1.5L7.5 7.5L5.5 1.5' stroke='currentColor' />
      <circle
        cx='1.5'
        cy='7.5'
        r='1.5'
        transform='rotate(-90 1.5 7.5)'
        fill='currentColor'
      />
      <circle
        cx='1.5'
        cy='1.5'
        r='1.5'
        transform='rotate(-90 1.5 1.5)'
        fill='currentColor'
      />
      <circle
        cx='7.5'
        cy='7.5'
        r='1.5'
        transform='rotate(-90 7.5 7.5)'
        fill='currentColor'
      />
      <circle
        cx='10.5'
        cy='1.5'
        r='1.5'
        transform='rotate(-90 10.5 1.5)'
        fill='currentColor'
      />
      <circle
        cx='5.5'
        cy='1.5'
        r='1.5'
        transform='rotate(-90 5.5 1.5)'
        fill='currentColor'
      />
      <circle
        cx='14.5'
        cy='7.5'
        r='1.5'
        transform='rotate(-90 14.5 7.5)'
        fill='currentColor'
      />
      <circle
        cx='14.5'
        cy='1.5'
        r='1.5'
        transform='rotate(-90 14.5 1.5)'
        fill='currentColor'
      />
    </SvgWrapper>
  ),
);

DownwardTreeIcon.displayName = 'DownwardTreeIcon';
